import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from "react-intl";
import { getI18n } from "../../utils/intl";
import styles from "./styles";
import { Box, Typography, makeStyles, withStyles } from '@material-ui/core';
import compose from 'recompose/compose';
import clsx from 'clsx';

export const SliderCaptcha = (props) => {
  const [isDisabled, setIsDisabled] = useState(false);
  const [focused, setFocused] = useState(false);
  const [sliderStyles, setSliderStyles] = useState({});

  const { sliderValue, setSliderValue, decideSliderReset } = props

  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const intl = getI18n(useIntl());

  const handleSliderChange = (e) => {
    //work around for firefox bug
    //on hovering over slider in disabled state,
    //it triggers on change event with
    //previous value of the slider
    if (isDisabled) { return; }
    setSliderValue(parseInt(e.target.value, 10));
    const newVal = Number(e.target.value);
    const negNewVal = -1 * newVal;

    setSliderStyles({
      left: newVal + '%',
      transform: 'translate(' + negNewVal + '%, 2px)',
    });

    if (newVal === 100) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  };

  useEffect(() => {
    if (decideSliderReset) {
      setIsDisabled(false);
      setSliderValue(1);
      setFocused(false);
      setSliderStyles({
        left: '0%',
        transform: 'translate(' + 0 + '%, 2px)',
      });
    }
  }, [decideSliderReset])

  const disableSliderClass = clsx(
    classes.rangeText, isDisabled && classes.disableSlider, { [classes.focused]: focused },
  );

  return (
    <Box className={classes.sliderContainer}>
      <input
        data-apim-test="registration-slider"
        type="range"
        min="1"
        max="100"
        value={sliderValue}
        onChange={handleSliderChange}
        disabled={isDisabled}
        className={classes.sliderField}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
      <Typography variant='subtitle2' id='range-text' style={sliderStyles} className={disableSliderClass}>{intl.getI18nMessage("label.signup.captcha.slider.text")}</Typography>
    </Box>
  );
}

SliderCaptcha.propTypes = {
  sliderValue: PropTypes.number,
  setSliderValue: PropTypes.func,
  decideSliderReset: PropTypes.bool,
}

export default compose(
  withStyles(styles),
)(SliderCaptcha);